<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="id"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Rejected user access requests</h1>

                    <a v-sanitizedHref="`/#/admin/organizations/users/requests/${id}`" class="btn btn-link btn-sm">
                        <i class="fa fa-users" aria-hidden="true"></i>
                        Pending requests
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <UsersTable v-if="rejected.length" :users="rejected" :showActive="false"></UsersTable>
            <h4 v-else>No rejected access requests</h4>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import { useUserAccessRequestsPage } from '@Organizations/Users/pages-core'
    import AdminNavigationV2 from "@common/AdminNavigationV2.vue";
    import UsersTable from "@Organizations/Users/Components/UsersTable.vue";

    const id = parseInt(useRoute().params.id)

    const { useUserAccessRequestsQuery } = useUserAccessRequestsPage()
    const { modelUserAccessRequestsQueryV1, runUserAccessRequestsQueryV1 } = useUserAccessRequestsQuery(id, false, true)
    const rejected = computed(() => modelUserAccessRequestsQueryV1.value?.Rejected || [])

    onMounted(() => {
        document.title = 'Rejected user access requests'
        runUserAccessRequestsQueryV1()
    })
</script>